import { __decorate } from "tslib";
import { LitElement, html, customElement, internalProperty } from 'lit-element';
import { getData } from './utils';
const selectableData = getData().map(i => {
    i.selected = false;
    return i;
});
let DemoMultiAction = class DemoMultiAction extends LitElement {
    constructor() {
        super(...arguments);
        this.data = selectableData;
        this.allSelected = false;
        this.openAction = false;
    }
    render() {
        return html `
      <cds-grid>
        <cds-grid-column width="90">
          <cds-checkbox>
            <label><span style="display: none">choose action for selected stocks</span></label>
            <input type="checkbox" .checked=${this.allSelected} @change=${(e) => this.selectAll(e)} name="grid-rows" />
          </cds-checkbox>
          <cds-inline-button id="multi-action" @click=${() => this.openAction = true} aria-label="filter column">
            <cds-icon shape="ellipsis-vertical"></cds-icon>
          </cds-inline-button>
          <cds-dropdown ?hidden=${!this.openAction} anchor="#multi-action" @hiddenChange=${() => this.openAction = false}>
            <cds-button action="flat" block size="sm" @click=${() => this.action('Purchased')}>Buy Selected</cds-button><br />
            <cds-button action="flat" block size="sm" @click=${() => this.action('Sold')}>Sell Selected</cds-button>
          </cds-dropdown>
        </cds-grid-column>
        <cds-grid-column>Stock</cds-grid-column>
        <cds-grid-column>Average</cds-grid-column>
        <cds-grid-column>Current</cds-grid-column>
        <cds-grid-column>About</cds-grid-column>
        ${this.data.map(entry => html `
          <cds-grid-row .select=${entry.selected}>
            <cds-grid-cell>
              <cds-checkbox>
                <label><span style="display: none">select all</span></label>
                <input type="checkbox" .checked=${entry.selected} value=${entry.id} @click=${(e) => this.select(entry, e.target.checked)} />
              </cds-checkbox>
            </cds-grid-cell>
            <cds-grid-cell>${entry.id}</cds-grid-cell>
            <cds-grid-cell>$${entry.average}</cds-grid-cell>
            <cds-grid-cell>$${entry.value}</cds-grid-cell>
            <cds-grid-cell>${entry.about}</cds-grid-cell>
          </cds-grid-row>
        `)}
        <cds-grid-footer></cds-grid-footer>
      </cds-grid>
    `;
    }
    select(entry, checked) {
        this.data.find(i => i.id === entry.id).selected = checked;
        this.data = [...this.data];
        this.allSelected = !this.data.find(i => !i.selected);
    }
    selectAll(e) {
        this.allSelected = e.target.checked;
        this.data.forEach(i => i.selected = e.target.checked);
    }
    action(name) {
        alert(`${name}: ${this.data.filter(i => i.selected).map(i => i.id).reduce((p, n) => `${p} ${n}`, '')}`);
        this.openAction = false;
        this.data.forEach(i => i.selected = false);
    }
    createRenderRoot() {
        return this;
    }
};
__decorate([
    internalProperty()
], DemoMultiAction.prototype, "data", void 0);
__decorate([
    internalProperty()
], DemoMultiAction.prototype, "allSelected", void 0);
__decorate([
    internalProperty()
], DemoMultiAction.prototype, "openAction", void 0);
DemoMultiAction = __decorate([
    customElement('demo-multi-action')
], DemoMultiAction);
export { DemoMultiAction };
//# sourceMappingURL=demo.row-multi-action.js.map